export default __webpack_public_path__ + "static/media/pasimage.89573946.jpg";